<template>
  <span
    class="status-chip"
    :class="`status-chip--${status}`"
    data-testid="status-chip"
    :aria-label="$t(`label.${status}`)"
  >
    <span class="status-chip__dot" />
    {{ $t(`label.${status}`) }}
  </span>
</template>

<i18n lang="yaml">
ja:
  label:
    active: 監視中
    inactive: 休止中

en:
  label:
    active: Active
    inactive: Inactive
</i18n>

<script>
export default {
  name: 'status-chip',
  props: {
    status: {
      type: String,
      required: true,
      validator: (v) => ['active', 'inactive'].includes(v),
    },
  },
};
</script>

<style scoped lang="sass">
.status-chip
  display: inline-flex
  align-items: center
  gap: 6px
  padding: 0 12px
  height: 24px
  border-radius: 12px
  font-size: 12px
  font-weight: 500
  border: 1px solid
  line-height: 1

  &__dot
    width: 8px
    height: 8px
    border-radius: 50%

  &--active
    background: #e8f5e9
    border-color: #4caf50
    color: #2e7d32

    .status-chip__dot
      background: #4caf50

  &--inactive
    background: #f5f5f5
    border-color: #9e9e9e
    color: #616161

    .status-chip__dot
      background: #9e9e9e
</style>
